/* eslint-disable no-unused-vars */
import { Button, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import API from "../../../../api";
import urls from "../../../../api/urls";
import Moment from "react-moment";
import "./style.scss";
import {
  capitaliseWithHyphen,
  normalizeService,
  serialNum,
} from "../../../../utils";
import moment from "moment";
import useCustomNavigate from "../../../../components/customNavigationHook";
import { useParams } from "react-router-dom";
const { GET_RECENT_BOOKING } = urls;

function NewRecentBookingTable({ recentBookingsData }) {
  const navigate = useCustomNavigate();
  const { type } = useParams();

  function MyComponent(dateToFormat) {
    const formattedTime = moment(dateToFormat)?.format("DD/MM/YYYY");
    return formattedTime || "NA";
  }

  const handleRedirect = (id, b) => {
    const dateNTime = b?.bookingTime;

    const formattedDate = moment(dateNTime).format("DD-MM-YYYY");

    navigate(`/ocr-bookings/${formattedDate}/${id}/OCR`, {
      state: {
        credit: true,
        retail: false,
      },
    });
  };

  const columns = [
    {
      title: "SI",
      width: 50,
      dataIndex: "sl",

      render: (a, b, idx) => serialNum(10, 0, idx),
    },
    {
      title: "AWB Number",
      dataIndex: "documentNo",
      key: "documentNo",
      className: "awbNumber",
      defaultSortOrder: "descend",
      width: 90,
      render: (text, b) => (
        <a onClick={() => handleRedirect(text, b)}>{text}</a>
      ),
    },
    {
      title: "Date",
      dataIndex: "bookingTime",
      key: "bookingTime",
      width: 60,
      render: (text, b) => MyComponent(text),
    },
    {
      title: (
        <>
          <span>
            Sender <br /> Name
          </span>
        </>
      ),
      dataIndex: "pickupAddress",
      key: "pickupAddress.name",
      width: 80,
      ellipsis: true,
      render: (text, b) => text?.name || "NA",
    },

    {
      title: (
        <>
          <span>
            Booking <br /> Type
          </span>
        </>
      ),
      width: 60,
      dataIndex: "bookingType",
      key: "bookingType",
      //   render: (text) =>
      //     text?.toUpperCase() === "ACCOUNT" ? "Credit" : "Retail",
    },
    {
      title: (
        <>
          <span>
            Doc <br /> Type
          </span>
        </>
      ),
      width: 50,
      dataIndex: "shipmentType",
      key: "shipmentType",
      ellipsis: true,
      render: (text) => capitaliseWithHyphen(text),
    },
    {
      width: 80,
      title: (
        <>
          <span>
            Service <br /> Type
          </span>
        </>
      ),
      dataIndex: "deliveryPromise",
      key: "deliveryPromise",
      ellipsis: true,
      render: (text) => normalizeService(text),
    },
    {
      width: 80,
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      ellipsis: true,
      render: (text, val) => capitaliseWithHyphen(text),
    },
    {
      title: (
        <>
          <span>
            Receiver <br /> Name
          </span>
        </>
      ),
      dataIndex: "receiverAddress",
      key: "receiverAddress.name",
      ellipsis: true,
      // sorter: true,
      width: 80,
      // filters: shipmentMode,
      // filteredValue: filteredInfo?.travelBy || null,
      // filterMultiple: false,
      render: (text, val) => capitaliseWithHyphen(text?.name) || "N/A",
    },
    {
      title: "To City",
      dataIndex: "receiverAddress",
      key: "receiverAddress.city",
      ellipsis: true,
      // sorter: true,

      width: 70,

      // filters: shipmentMode,
      // filteredValue: filteredInfo?.travelBy || null,

      // filterMultiple: false,
      render: (text, val) => capitaliseWithHyphen(text?.city) || "N/A",
    },
    {
      title: "Weight",
      dataIndex: "volumetricWeight",
      key: "volumetricWeight",
      ellipsis: false,
      width: 60,
      render: (text, val) => Math.round(text, 2) || "N/A",
    },
  ];

  return (
    <div className="recent-booking-container">
      <div className="space-between">
        <h4 className="ml-1" style={{ fontSize: "16px" }}>
          {type == "OCR" ? "Pending OCR Bookings" : "Recent bookings"}
        </h4>
        <Button
          style={{
            border: "none",
            color: "#2e77d0",
            fontSize: "16px",
            padding: "2px",
          }}
          onClick={() => {
            if (type == "OCR") {
              navigate("/viewBooking", { state: { currentTab: "5" } });
            }
          }}
        >
          View all
        </Button>
      </div>
      <Table
        dataSource={recentBookingsData}
        columns={columns}
        pagination={false}
        size="small"
      />
    </div>
  );
}

export default React.memo(NewRecentBookingTable);
